
jQuery(document).ready(function ($) {
  if (typeof pageprocesso !== 'undefined' || document.getElementById('bolsa-interno')) {
    function SetImagesToFileType() {
      // Get all the 'edital' elements
      const editais = document.querySelectorAll('.edital');

// Iterate over each 'edital' element
      editais.forEach((edital) => {
        // Get the file extension from the href attribute of the anchor element
        const fileExtension = edital.querySelector('.edital__arquivo a').getAttribute('href').split('.').pop().toLowerCase();

        // Get the child 'img' element within 'edital__arquivo'
        const imgElement = edital.querySelector('.edital__arquivo img');

        // Set the source (src) attribute based on the file extension
        if (fileExtension === 'pdf') {
          imgElement.setAttribute('src', '/themes/furb2020/images/pdf-svgrepo-com.svg');
        } else if (['mp3', 'wav', 'ogg', 'aac'].includes(fileExtension)) {
          imgElement.setAttribute('src', '/themes/furb2020/images/audio-file.png');
        } else if (fileExtension === 'docx' || fileExtension === 'doc') {
          imgElement.setAttribute('src', '/themes/furb2020/images/doc-file.png');
        } else {
          // Set a default image source if the file extension is unknown or not handled
          imgElement.setAttribute('src', '/themes/furb2020/images/default-file.svg');
        }
      });
    }
    SetImagesToFileType();
  }
  if (typeof pageprocesso !== 'undefined') {
  }
});
